export default __webpack_public_path__ + "static/media/SWT0560.34I-18844_-25289_0.40218cd4.jpg";